<div class="quote-selection-page">

    <!-- Background -->
    <div class="quote-background"></div>

    <!-- Main Content -->
    <main class="quote-selection-container">

        <!-- ================================================= -->
        <!-- PROGRESS -->
        <!-- ================================================= -->

        <div class="quote-progress">

            <span class="step-number">
                STEP 01 / 05
            </span>

            <div class="progress-track">
                <div class="progress-fill" [style.width]="'20%'"></div>
            </div>

            <span class="step-label">
                CHOOSE YOUR QUOTE
            </span>

        </div>


        <!-- ================================================= -->
        <!-- HEADING -->
        <!-- ================================================= -->

        <section class="quote-heading">

            <h1>
                Choose your
                <span>quote.</span>
            </h1>

            <p>
                Every quote is neutral, consistent, and delivered
                in 72 hours or less, 7 days a week.
            </p>

        </section>


        <!-- ================================================= -->
        <!-- LOADING -->
        <!-- ================================================= -->

        <div class="quote-loader" *ngIf="isLoading">

            <div class="loader-spinner"></div>

            <span>
                Loading quote options...
            </span>

        </div>


        <!-- ================================================= -->
        <!-- PRODUCT OPTIONS -->
        <!-- ================================================= -->

        <section class="quote-products" *ngIf="!isLoading && products.length > 0">


            <!-- ============================================= -->
            <!-- FULL SPEKWO                                   -->
            <!-- ============================================= -->

            <button type="button" class="quote-product-card" *ngIf="fullProduct"
                [class.selected]="isSelected(fullProduct)" (click)="selectProduct(fullProduct)">

                <!-- Selected Indicator -->
                <span class="selected-check" *ngIf="isSelected(fullProduct)">
                    ✓
                </span>


                <span class="product-label">
                    FULL REPORT
                </span>


                <span class="product-name">
                    The Full speKwo
                </span>


                <span class="product-price">
                    ${{ fullProduct.productPrice }}
                </span>


                <span class="product-description">
                    Every repair/replace item on your
                    inspection report, quoted.
                </span>

            </button>


            <!-- ============================================= -->
            <!-- ITEMIZED SOLUTION ESTIMATE                   -->
            <!-- ============================================= -->

            <button type="button" class="quote-product-card" *ngIf="itemizedProduct"
                [class.selected]="isSelected(itemizedProduct)" (click)="selectProduct(itemizedProduct)">

                <!-- Selected Indicator -->
                <span class="selected-check" *ngIf="isSelected(itemizedProduct)">
                    ✓
                </span>


                <span class="product-label">
                    CLIENT CHOICE
                </span>


                <span class="product-name">
                    Itemized Solution Estimate
                </span>


                <span class="product-price">
                    ${{ itemizedProduct.productPrice }}
                </span>


                <span class="product-description">
                    Up to 40 items you choose from your
                    recent inspection.
                </span>

            </button>


            <!-- ============================================= -->
            <!-- PRE-LIST QUOTE                                -->
            <!-- ============================================= -->

            <button type="button" class="quote-product-card" *ngIf="preListProduct"
                [class.selected]="isSelected(preListProduct)" (click)="selectProduct(preListProduct)">

                <!-- Selected Indicator -->
                <span class="selected-check" *ngIf="isSelected(preListProduct)">
                    ✓
                </span>


                <span class="product-label">
                    FOR SELLERS
                </span>


                <span class="product-name">
                    Pre-List Quote
                </span>


                <span class="product-price">
                    ${{ preListProduct.productPrice }}
                </span>


                <span class="product-description">
                    1–2 pictures per item, before you go
                    on the market.
                </span>

            </button>

        </section>


        <!-- ================================================= -->
        <!-- NO PRODUCTS                                      -->
        <!-- ================================================= -->

        <div class="no-products" *ngIf="
                !isLoading &&
                products.length === 0
            ">

            <h3>
                Quote options are currently unavailable.
            </h3>

            <p>
                Please try again shortly.
            </p>

        </div>


        <!-- ================================================= -->
        <!-- CONTINUE BUTTON                                  -->
        <!-- ================================================= -->

        <div class="quote-navigation" *ngIf="
                !isLoading &&
                products.length > 0
            ">

            <button type="button" class="continue-button" [class.disabled]="!selectedProduct"
                [disabled]="!selectedProduct" (click)="continueToQuote()">

                <span>
                    Continue
                </span>

                <span class="arrow">
                    →
                </span>

            </button>

        </div>


        <!-- ================================================= -->
        <!-- FOOT NOTE                                        -->
        <!-- ================================================= -->

        <div class="quote-footer-note">

            <span>
                NEUTRAL REPAIR QUOTES
            </span>

            <span>•</span>

            <span>
                24–72 HRS
            </span>

            <span>•</span>

            <span>
                7 DAYS A WEEK
            </span>

        </div>

    </main>

</div>